import { useState } from 'react'
import { useHistory } from 'react-router'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Alert, { ActionsOptType } from '../../../components/Alert'
import DialogContentText from '@material-ui/core/DialogContentText'

// Define IDialogEnd interface
interface IDialogEnd {
  open: boolean
  setOpen: (newState: boolean) => void
}
  
/**
 * Custom `EndServiceDialog` component declaration.
 * This component is used to end the creation of the document with a custom message and redirect the user
 * @param {boolean} open
 * @param {Funtion} setOpen
 * @return EndServiceDialog
*/
const EndServiceDialog = ({
    open,
    setOpen,
  }: IDialogEnd): JSX.Element => {
  const history = useHistory()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to close dialog
   * @Return {void}
  */
  const handleClose = () => {
    setOpen(false)
  }

  /**
   * This is used to redirect the app.
   */
  const goDocuments = async () => {
    history.push('/documents') 
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <DialogContent>
        <DialogContentText style={{whiteSpace: 'pre-line'}}>
          {'\n !El documento a sido culminado con éxito! '}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={goDocuments} color="primary">
          Ir a mis solicitudes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EndServiceDialog